import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Checkbox from '../../Checkbox/Checkbox';

export interface ControlledCheckboxProps {
  label?: string;
  name: string;
  disabled?: boolean;
}

const ControlledCheckbox: FC<ControlledCheckboxProps> = ({
  label,
  name,
  disabled,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      defaultValue=""
      name={name}
      render={({ field: { value, onChange } }) => (
        <Checkbox
          label={label}
          checked={value}
          onChange={onChange}
          disabled={disabled}
          error={errors[name]}
        />
      )}
    />
  );
};

export default ControlledCheckbox;
